import { render, staticRenderFns } from "./pressRelease.vue?vue&type=template&id=7d662f72&"
import script from "./pressRelease.vue?vue&type=script&lang=js&"
export * from "./pressRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports